<template>
    <div>
        <div class="case-tabs">
          <router-link to="/ured">
            <div :class="['case-tab case-tab-osobe', active_link == 0 ? 'active':'']">{{ $t('office_management.navigation.quick_purchase') }}</div>
          </router-link>
          <!-- <router-link to="/assets">
            <div :class="['case-tab case-tab-osobe', active_link == 1 ? 'active':'']">{{ $t('office_management.navigation.assets') }}</div>
          </router-link>

          <router-link to="/assets-services">
            <div :class="['case-tab case-tab-osobe', active_link == 2 ? 'active':'']">{{ $t('office_management.navigation.services') }}</div>
          </router-link> -->
        </div>
    </div>
</template>

<script>
export default {
    name : "NavigationOfficeManagement",
    props : {
        "active_link" : Number
    }
}
</script>